import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { GamePlan } from '../../features/gamePlan/GamePlan';
import { GameplanBannerSection } from '../../features/gamePlan/gameplanBannerSection/GameplanBannerSection';
import { GuidanceSection } from '../../features/gamePlan/guidanceSection/GuidanceSection';
import { useGetGamePlanQuery } from '../../features/gamePlan/gamePlanSlice';
import {
    selectCurrentEmpid,
    selectCurrentUserManagerLevel,
    selectCurrentUserParentClient,
} from '../login/authSlice';
import './gamePlanPage.scss';
import { ROLES } from '../../constants';
import { UserHierarchyFilters } from '../../components/userHierarchyFilter/UserHierarchyFilters';

export const GamePlanPage = () => {
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const currentUserParentClient = useSelector(selectCurrentUserParentClient);

    const [selectedTeamLead, setSelectedTeamLead] = useState<any>();

    const { data: gamePlanData } = useGetGamePlanQuery(
        {
            employeenumber: ROLES.Supervisor2AndAbove.includes(userManagerLevel)
                ? selectedTeamLead
                : loggedEmpNum?.toString(),
        },
        {
            skip: !loggedEmpNum,
        }
    );

    return (
        <div id="gamePlanId" className="layout-wrapper">
            <div className="layout-content">
                <div className="main-content">
                    {ROLES.Supervisor2AndAbove.includes(userManagerLevel) && (
                        <UserHierarchyFilters
                            userParentClient={currentUserParentClient}
                            setSelectedTL={setSelectedTeamLead}
                        />
                    )}
                    <div className="main-sections">
                        <GameplanBannerSection gamePlan={gamePlanData} />
                        <div className="sections-row">
                            <div className="metrics-section">
                                <GamePlan gamePlan={gamePlanData} />
                            </div>
                            <div className="guidance-section">
                                <GuidanceSection />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
